export class InfoRoomTicket {
  thongTinPhim = new InfoMovie();
  danhSachGhe = [];
}
export class InfoMovie {
  maLichChieu = "";
  tenCumRap = "";
  tenRap = "";
  diaChi = "";
  tenPhim = "";
  hinhAnh = "";
  ngayChieu = "";
  gioChieu = "";
}
export class Seet {
  maGhe = "";
  tenGhe = "";
  maRap = "";
  loaiGhe = "";
  stt = "";
  daDat = "";
  taiKhoanNguoiDat = "";
}
